import {TranslateHelper} from '@binotel-frontend/bnt-common-components';
import {IPageAndSort} from '@entities/api';
import {ESubjectSyncStatuses} from '@entities/subject';
import {Action} from '@ngrx/store';
import {SnackbarHelper} from '@shared/helper';
import {
  catchError,
  first,
  interval,
  map,
  Observable,
  of,
  Subject,
  switchMap,
  takeUntil,
  tap,
  timer,
} from 'rxjs';

import {SearchActions} from './search.actions';
import {SearchApi} from './search.api';

const POLLING_INTERVAL_MS = 1000;
const SNACKBAR_WAITING_DELAY_MS = 10000;
const SNACKBAR_LONG_WAITING_DELAY_MS = 20000;

const SYNC_COMPLETED_STATUSES = [
  ESubjectSyncStatuses.Success,
  ESubjectSyncStatuses.Failed,
  ESubjectSyncStatuses.NeedSync,
];

function isSyncCompleted(status: ESubjectSyncStatuses): boolean {
  return SYNC_COMPLETED_STATUSES.includes(status);
}

export function pollUntilSynced(
  api: SearchApi,
  query: string,
  pagination?: IPageAndSort
): Observable<Action> {
  SnackbarHelper.open(TranslateHelper.translate('search.wait-some-time'));

  const pollingDone$ = new Subject<void>();

  timer(SNACKBAR_WAITING_DELAY_MS)
    .pipe(
      tap(() =>
        SnackbarHelper.open(TranslateHelper.translate('search.still-waiting'))
      ),
      takeUntil(pollingDone$)
    )
    .subscribe();

  timer(SNACKBAR_LONG_WAITING_DELAY_MS)
    .pipe(
      tap(() =>
        SnackbarHelper.open(
          TranslateHelper.translate('search.still-waiting-long')
        )
      ),
      takeUntil(pollingDone$)
    )
    .subscribe();

  return interval(POLLING_INTERVAL_MS).pipe(
    switchMap(() => api.getSubjectsCheck({query, pagination})),
    first((res) => isSyncCompleted(res.syncStatus)),
    tap(() => pollingDone$.next()),
    map(() => SearchActions.searchSubjects.requested({query, pagination})),
    catchError(() =>
      of(SearchActions.searchSubjects.failed({error: 'Sync polling failed'}))
    )
  );
}
